import { mediaData } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1300px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            精选视频
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base max-w-[600px] mx-auto">
            编辑团队每日精选最新最热的影视资源，4K超清画质，即刻畅享
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-5">
          {mediaData.map((item) => (
            <div
              key={item.id}
              className="group cursor-pointer"
            >
              <div className="relative aspect-[2/3] rounded-lg overflow-hidden bg-background-100">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                    (target.parentElement as HTMLElement).style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>
                <span className="absolute top-2 left-2 px-2 py-0.5 bg-primary-500 text-background-50 text-[10px] font-semibold rounded whitespace-nowrap">
                  {item.quality}
                </span>
                <span className="absolute top-2 right-2 px-2 py-0.5 bg-background-950/60 text-accent-400 text-[10px] font-bold rounded whitespace-nowrap">
                  {item.rating}
                </span>
                <div className="absolute bottom-0 left-0 right-0 p-3">
                  <span className="block text-[10px] text-primary-300 font-medium mb-0.5 whitespace-nowrap">
                    {item.tag}
                  </span>
                  <h3 className="text-sm font-semibold text-background-50 leading-tight truncate">
                    {item.title}
                  </h3>
                  <div className="flex items-center gap-2 mt-1.5 text-[10px] text-background-300">
                    <span>{item.year}</span>
                    <span className="w-0.5 h-0.5 rounded-full bg-background-500"></span>
                    <span>{item.duration}</span>
                    <span className="w-0.5 h-0.5 rounded-full bg-background-500"></span>
                    <span>{item.views}播放</span>
                  </div>
                </div>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50">
                    <i className="ri-play-fill text-2xl"></i>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}